import {useEffect,useRef,useState} from 'react';
import api from '../../api/api';
export default function TicketTypePicker({departmentId,value,onChange}){
 const [data,setData]=useState(null),[error,setError]=useState('');
 const callback=useRef(onChange);callback.current=onChange;
 useEffect(()=>{let active=true;api('/tickets/lifecycle/create-options').then(result=>{if(active)setData(result);}).catch(e=>{if(active)setError(e.message);});return()=>{active=false;};},[]);
 const selected=departmentId||data?.default_department_id;
 const types=data?.types?.filter(t=>t.department_id===selected)||[];
 useEffect(()=>{
  if(!data?.enabled)return;
  const available=data.types.filter(t=>t.department_id===(departmentId||data.default_department_id));
  if(!available.some(t=>String(t.id)===String(value))){const issue=available.find(t=>t.key==='issue')||available[0];if(issue)callback.current(issue.id,departmentId?undefined:data.default_department_id);}
  else if(!departmentId)callback.current(Number(value),data.default_department_id);
 },[data,departmentId,value]);
 if(error)return <p role="alert" className="text-red-600">{error}</p>;
 if(!data?.enabled)return null;
 return <label className="block my-3">Ticket type <select className="border rounded p-2 ml-2 bg-[var(--nj-surface-secondary)] text-[var(--nj-text)]" value={value??''} onChange={e=>onChange(Number(e.target.value))}>{types.map(t=><option key={t.id} value={t.id}>{t.name}</option>)}</select></label>;
}
